module.exports = __webpack_public_path__ + "static/media/girl-work-on-laptop-1792788-1519329.cac4a386.png";